import { combineReducers } from 'redux'

import deleteNode from './categories/delete'
import get from './categories/get'
import list from './categories/list'
import post from './categories/post'
import put from './categories/put'
import reorder from './categories/reorder'

export default combineReducers({
  delete: deleteNode,
  get,
  list,
  post,
  put,
  reorder
})



// WEBPACK FOOTER //
// ./src/reducers/root/entities/categories.js